import { useAuth } from "../../contexts/AuthContext";

export function usePermissao() {
    const { userInfo } = useAuth();

    const temPermissao = (acao) => {
        if(!userInfo?.permissoes) return false;
        return userInfo.permissoes.includes(acao);
    }

    return { temPermissao };
}